import styles from '../globals/pages.module.scss'

import { useEffect, useState } from 'react'
import axios from 'axios'
import { useParams, useSearchParams } from 'react-router-dom'

import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { browserName, osName, deviceDetect, getUA } from 'react-device-detect'

import { Wrapper, SignaturePad } from '../components/reusable'
import CfaBanner from '../components/cfaBanner'
import SingleSignatureContainer from '../components/singleSigContainer'
import { apiErrors } from '../helpers/apiErrors'
import PocView from '../components/pocView'
import { useUpdateClaimData } from '../claimProvider'
import LCCfaBanner from '../components/LCCfaBanner'
import Modal from '../components/reusable/modal'
import Previewer from '../components/reusable/previewer'
import LCILCfaBanner from '../components/LCILCfaBanner'
import OpenBanking from '../components/OpenBanking'

export default function CfaLCIL() {
    const [cfaData, setCfaData] = useState([])
    const [retrievedCfa, setRetrievedCfa] = useState(false)
    const [currentClaim, setCurrentClaim]: any = useState({})
    const [cfaModalState, setCfaModalState] = useState(false)
    const [loaModalState, setLoaModalState] = useState(false)
    const [showOpenBanking, setShowOpenBanking] = useState(false)
    const [openBankingData, setOpenBankingData] = useState<any>({})
    const [isLoading, setIsLoading] = useState(false)
    const { token } = useParams()
    const updateClaim = useUpdateClaimData()

    const [searchParams] = useSearchParams()
    // const chase_id = searchParams.get('chase_id')
    // const agent = searchParams.get('agent')
    useEffect(() => {
        if (!retrievedCfa) {
            Loading.standard('Loading...')
            // console.log('chase_id=', chase_id)
            axios
                .post(`${process.env.REACT_APP_API_TOKEN_URL}/lc-cfa-il`, { token })
                .then((response) => {
                    const responseData = response.data
                    if (responseData == 'CFA Complete') {
                        Report.success('Document Signed', 'Your Document has already been signed.', 'Okay', () => {
                            window.location.href = 'https://sentinellegal.co.uk'
                        })
                    }

                    const signatureData = responseData.sigData
                    console.log(signatureData)

                    if (!signatureData) throw new Error(responseData)
                    localStorage.setItem('name', `${signatureData.first_name} ${signatureData.last_name}`)

                    setCfaData(signatureData)
                    setCurrentClaim(signatureData)
                    setRetrievedCfa(true)
                    updateClaim(signatureData)

                    Loading.remove()
                })
                .catch((e) => {
                    console.error('error:', e)
                    const serverError = e.response.data
                    Loading.remove()
                    apiErrors(serverError)
                })
        }
    }, [])

    const displayOpenBanking = (obj: any) => {
        setIsLoading(true)

        setTimeout(() => {
            setIsLoading(false)
        }, 300)
        setOpenBankingData(obj.openBankingLink)
        setShowOpenBanking(true)
    }

    const handleCfaModal = () => {
        setCfaModalState(!cfaModalState)
    }

    return (
        <div className={`${styles.pageContent} ${styles.pocContent}`}>
            <LCILCfaBanner />
            <Wrapper>
                {!showOpenBanking ? (
                    <>
                        <div>
                            <div className={styles.centeredContainer}>
                                <h2 className={styles.headerTitle}>
                                    You might be eligible for an irresponsible lending claim
                                </h2>
                                <span className={styles.headerDivider}></span>
                                <p
                                    style={{ textAlign: 'center', maxWidth: '700px', margin: '0 auto' }}
                                    className={styles.centeredText}
                                >
                                    If you've ever had a credit card, unsecured loan, store cards or catalogue, there's
                                    a high chance the lender didn't do the proper eligibility checks.
                                </p>
                                <br />
                            </div>
                        </div>
                        <PocView>
                            {retrievedCfa ? (
                                <>
                                    <div className={styles.narrowContainer}>
                                        <SignaturePad
                                            additionalAction={(data) => displayOpenBanking(data)}
                                            extraPayload={{
                                                type: 'lc-cfa-signature-il',
                                                noDuplicateClaimConsent: false,
                                                metadata: {
                                                    browser: browserName,
                                                    device: osName,
                                                    // chase_id,
                                                    // agent,
                                                },
                                            }}
                                            disclaimer="*By signing this document, you agree that Sentinel Legal can do a soft credit check to look at your lending history, check who you are, and stop money laundering. This check won't affect your credit score, and we will only look at information about your lending history. You also agree that Sentinel Legal can use your signature to complete all claims we find in your name. This will allow us to fill out and send the necessary forms for each claim. Your signature will only be used for claims linked to you, and you can ask us to stop using it at any time."
                                        />
                                        <div className={styles.previewDocumentsContainer}>
                                            <h3>Preview your documents</h3>
                                            <div className={styles.buttonContainer}>
                                                <button onClick={handleCfaModal} className={styles.actionButton}>
                                                    Preview your CFA document
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <Modal modalState={cfaModalState} previewModalAction={handleCfaModal}>
                                        <Previewer url={currentClaim.cfa_doc_url} />
                                    </Modal>
                                </>
                            ) : (
                                <></>
                            )}
                        </PocView>
                    </>
                ) : (
                    <div className={styles.narrowContainer}>
                        <OpenBanking
                            openBankingData={openBankingData}
                            isLoading={isLoading}
                            onLoadingChange={setIsLoading}
                        />
                    </div>
                )}
            </Wrapper>
        </div>
    )
}
